
import MainDialogCard from '@/components/MainDialogComponents/MainDialogCard.vue';
import PartnerLogo from '@/components/PartnerLogo/PartnerLogo.vue';
import WsaTextField from '@/components/UI/TextFields/WsaTextField.vue';
import PartnerSettings from '@/models/PartnerSettings';
import Vue from 'vue'
import { mapMutations, mapState } from 'vuex'
import { isRudderStack } from '@/analytics/analyticsMode'
export default Vue.extend({
  components: { WsaTextField, MainDialogCard, PartnerLogo },

    data:() => ({
        params: {
            subject: ""
        }
    }),

    computed: {
        ...mapState("partner", ["partnerSettings", "appDataContent"])
    },

    methods: {
        ...mapMutations(["LOG_RS_EVENT"]),

        backBtnClicked() {
            this.$emit("closeDialog");
        },

        openWpChat(){
            if (isRudderStack()) {
                this.LOG_RS_EVENT({ event: "WhatsApp Button Click" });
            }

            var anchor = document.createElement('a');
            anchor.href = `https://wa.me/${(this.partnerSettings as PartnerSettings).customerServiceWhatsAppNumber}`;
            anchor.target="_blank"
            anchor.click();
        }
    }
})
